/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./supplier-create-action-body').SupplierCreateActionBody} SupplierCreateActionBody
 */

/**
 * @typedef {import('./supplier-create-action-response').SupplierCreateActionResponse} SupplierCreateActionResponse
 */

/**
 * The path of the SupplierCreateAction action.
 */
export const supplierCreateActionPath = new SweetPath('/api/project/supplier', { path: '{param}' });

/**
 * Creates a contextualized SupplierCreateAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createSupplierCreateAction(axios) {
  /**
   * The supplierCreateAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,body: SupplierCreateActionBody } }
   *
   * @returns {Promise<SupplierCreateActionResponse>}
   */
  function supplierCreateAction({ headers = {}, parameters = {}, body } = {}) {
    const path = supplierCreateActionPath.insert(parameters);

    return axios.post(path, body, { headers });
  }

  return supplierCreateAction;
}
